import { FC, Button, useMemo } from 'external/react'
import { clsx } from 'external/clsx'

import usePublic from 'context/public-context/hook'
import usePayment from 'context/payment-context/hook'

const ContinueButton: FC = () => {

    const {basicCoursesInCart} = usePayment() 
    const {navigation} = usePublic()

    const [hide, disabled, to] = useMemo(() => {
        const disabled = basicCoursesInCart.length < 5 ? true : undefined
        const hide = navigation.offers.active || navigation.summary.active
        const to = navigation.summary.link()
        return  [hide, disabled, to]
    }, [navigation, basicCoursesInCart])

	return (
        <li className={clsx('nav-item', 'me-4', {'d-none': hide})}>
            <Button disabled={disabled} className='btn btn-purple' href={to}>
                Continuar
            </Button>
        </li>
	)
}

export default ContinueButton